module.exports = __webpack_public_path__ + "static/Logo_ighi_white-7255a11eee71d7c160fc0e90347da275.svg";